import PriceAdjustmentCondition from "@/model/PriceAdjustmentCondition";
export default class PriceAdjustmentRule {
    id = 0;
    adjustmentAmount = 0;
    conditions = [new PriceAdjustmentCondition()];
    init(other) {
        this.id = other.id;
        this.adjustmentAmount = other.adjustmentAmount;
        this.conditions = other.conditions.map(condition => {
            const newCondition = new PriceAdjustmentCondition();
            newCondition.init(condition);
            return newCondition;
        });
    }
}
